// Central site configuration – swap brand/contact info in one place.
export const SITE = {
  brand: {
    name: "Tobias Nunner",
    fullName: "Tobias Nunner · NNR Coaching",
    tagline: "NNR Coaching",
    owner: "Tobias Nunner",
    monogram: "TN",
  },
  contact: {
    phone: "+49 176 84211137",
    phoneDisplay: "+49 176 84211137",
    whatsapp: "4917684211137",
    email: "mail@tobinunner.de",
    address: {
      street: "Seestraße 107",
      zip: "63110",
      city: "Rodgau",
      country: "Deutschland",
    },
    hours: [
      { day: "Mo – Fr", time: "08:00 – 20:00" },
      { day: "Sa", time: "09:00 – 16:00" },
      { day: "So", time: "Geschlossen" },
    ],
    social: {
      instagram: "https://instagram.com/",
      youtube: "https://youtube.com/",
      tiktok: "https://tiktok.com/",
    },
  },
  whatsappMessage: "Hallo Tobias, ich interessiere mich für dein Coaching.",
  services: [
    {
      id: "kochbuch",
      title: "Kochbuch",
      price: "17 €",
      tag: "Ernährung",
      cta: "Jetzt kaufen",
      purchaseUrl: "",
      desc:
        "Über 70 alltagstaugliche Rezepte für Muskelaufbau, Fettabbau und eine gesunde Ernährung.",
      bullets: [
        "70+ ausgewogene Rezepte",
        "Frühstück, Hauptmahlzeiten, Desserts usw.",
        "Leckere & einfache Rezepte",
      ],
    },
    {
      id: "trainingsplaene",
      title: "Trainingspläne",
      price: "50 €",
      tag: "Training",
      cta: "Jetzt kaufen",
      purchaseUrl: "",
      desc:
        "Vorgefertigte Trainingspläne für unterschiedliche Trainingsfrequenzen. Klare Struktur, professionell aufgebaut.",
      bullets: [
        "Modell 2 Tage / Woche",
        "Modell 3 Tage / Woche",
        "Modell 4 Tage / Woche",
        "Modell 5 Tage / Woche",
        "Modell 6 Tage / Woche",
      ],
    },
    {
      id: "ernaehrungsplan",
      title: "Ernährungsplan",
      price: "50 €",
      tag: "Ernährung",
      cta: "Jetzt kaufen",
      purchaseUrl: "",
      desc:
        "Vorgefertigter Ernährungsplan für Muskelaufbau, Fettverlust oder gesunde Ernährung.",
      bullets: [
        "Klare Wochenstruktur",
        "Makro- und Nährstoffangaben",
        "Auswahl an Rezeptvorschlägen",
        "Sofort einsetzbar",
      ],
    },
    {
      id: "coaching-3",
      title: "3 Monate Coaching",
      price: "Auf Anfrage",
      tag: "Premium 1:1",
      cta: "Anfrage stellen",
      desc:
        "1:1 individuelles Coaching. Trainingsplan, Ernährungsplan und persönliche Betreuung – abgestimmt auf deinen Alltag.",
      bullets: [
        "Tiefe individuelle Anpassung",
        "Individueller Trainingsplan",
        "WhatsApp Support",
        "Wöchentliche Anpassungen",
        "Regelmäßige Check-ins",
        "Fortschrittskontrolle",
      ],
      highlight: true,
    },
    {
      id: "coaching-6",
      title: "6 Monate Coaching",
      price: "Auf Anfrage",
      tag: "Premium 1:1",
      cta: "Anfrage stellen",
      desc:
        "1:1 individuelles Coaching. Trainingsplan, Ernährungsplan und persönliche Betreuung – abgestimmt auf deinen Alltag.",
      bullets: [
        "Tiefe individuelle Anpassung",
        "Individueller Trainingsplan",
        "WhatsApp Support",
        "Wöchentliche Anpassungen",
        "Regelmäßige Check-ins",
        "Fortschrittskontrolle",
      ],
      highlight: true,
    },
    {
      id: "gruppencoaching",
      title: "Gruppencoaching",
      price: "auf Anfrage",
      tag: "Community",
      cta: "Anfrage stellen",
      desc:
        "Gemeinsam trainieren, gemeinsam wachsen. Struktur, Motivation und ehrliches Feedback im Gruppenformat.",
      bullets: [
        "Allgemeine Trainingsstruktur",
        "Ernährungshinweise",
        "Gruppenchat & Calls",
        "Motivation & Austausch",
      ],
    },
    {
      id: "firmen-events",
      title: "Firmen-Events",
      price: "auf Anfrage",
      tag: "Business",
      cta: "Anfrage stellen",
      desc:
        "Individuelle Fitness-, Gesundheits- und Motivationsevents für Unternehmen. Aktivierend, professionell, wirksam.",
      bullets: [
        "Teambuilding-Formate",
        "Fitness Challenges",
        "Live Coaching & Vorträge",
        "Gesundheitsaktionen",
        "Firmenfitness Tage",
      ],
    },
    {
      id: "community",
      title: "Community & Accountability",
      price: "inklusive",
      tag: "Bonus",
      cta: "Mehr erfahren",
      desc:
        "Gemeinsam bleibt man dran. In ausgewählten Coaching-Programmen enthalten.",
      bullets: [
        "Gruppenchat & gegenseitiger Support",
        "Erfahrungsaustausch",
        "Motivation durch Challenges",
        "Gemeinsame Ziele",
      ],
    },
  ],
  faqs: [
    {
      q: "Wie läuft das Coaching ab?",
      a: "Nach deiner Anfrage vereinbaren wir ein persönliches Erstgespräch. Auf Basis deiner Ziele, deines Levels und deines Alltags entsteht anschließend ein individueller Trainings- und Ernährungsplan – kombiniert mit durchgehendem WhatsApp Support und regelmäßigen Check-ins.",
    },
    {
      q: "Für wen eignet sich das Coaching?",
      a: "Für alle, die nachhaltig an Gesundheit, Kraft und Leistungsfähigkeit arbeiten möchten – vom Einsteiger bis zum Fortgeschrittenen. Der Fokus liegt auf individuellem Krafttraining, Ernährung und Schlaf, abgestimmt auf deinen Alltag und deine persönlichen Ziele.",
    },
    {
      q: "Ist das Coaching wirklich individuell?",
      a: "Ja. Trainings- und Ernährungspläne im 1:1 Coaching werden auf dein Level, deine Ziele, dein Zeitbudget und deinen Alltag zugeschnitten. Es gibt keine Standard-Programme im Coaching.",
    },
    {
      q: "Was ist der Unterschied zu den vorgefertigten Plänen?",
      a: "Die Trainings- und Ernährungspläne für je 50 € sind hochwertig aufgebaut, aber nicht individualisiert. Individuelle Pläne gibt es ausschließlich als Teil des 1:1 Coachings.",
    },
    {
      q: "Kann ich auch als Anfänger starten?",
      a: "Ja. Wir starten dort, wo du stehst. Die Progression wird an dein aktuelles Level angepasst, damit Fortschritt gesund und nachhaltig entsteht.",
    },
    {
      q: "Wie funktioniert die Ernährung im Coaching?",
      a: "Statt starrer Verbote bekommst du klare Empfehlungen, Beispielwochen, Rezepte und Makro-Vorgaben – abgestimmt auf dein Ziel. Nachhaltige Ernährung, die zu deinem Leben passt.",
    },
    {
      q: "Wie ist der Support geregelt?",
      a: "Du hast direkten Draht zu Tobias via WhatsApp. Schnelle Antworten, ehrliches Feedback und echte Betreuung – kein anonymer Support-Chat.",
    },
    {
      q: "Wie laufen die Calls ab?",
      a: "Regelmäßige Video- oder Sprach-Calls dienen der Fortschrittskontrolle, dem Feintuning des Plans und der Zielanpassung. Struktur, die dranbleiben leichter macht.",
    },
    {
      q: "Wie lange dauert die Zusammenarbeit?",
      a: "Coaching-Programme laufen 3 oder 6 Monate. Gruppencoaching und Community-Formate laufen fortlaufend.",
    },
    {
      q: "Was kostet das Coaching?",
      a: "Coaching-Pakete werden auf Anfrage individuell besprochen, da Umfang und Betreuung an dein Ziel angepasst sind. Fixe Preise: Kochbuch 17 €, Trainingsplan 50 €, Ernährungsplan 50 €.",
    },
    {
      q: "Gibt es auch Angebote für Unternehmen?",
      a: "Ja. Firmen-Coaching und Firmen-Events sind speziell für Teams konzipiert – von Workshops und Gesundheitsvorträgen bis zu Firmenfitness-Tagen.",
    },
    {
      q: "Wie starte ich?",
      a: "Formular ausfüllen, WhatsApp schreiben oder direkt anrufen. Tobias meldet sich persönlich innerhalb von 24 Stunden zurück.",
    },
  ],
  testimonials: [
    {
      name: "Marco S.",
      role: "6 Monate Coaching",
      stars: 5,
      text: "Klare Struktur, ehrliches Feedback und echte Betreuung. Mein Training und meine Ernährung sind endlich auf einem Level, das nachhaltig funktioniert.",
    },
    {
      name: "Lisa K.",
      role: "3 Monate Coaching",
      stars: 5,
      text: "Endlich ein Coach, der mitdenkt. Der Plan passt in meinen Alltag und die Betreuung ist auf einem professionellen Niveau, das ich so nicht kannte.",
    },
    {
      name: "Daniel R.",
      role: "Gruppencoaching",
      stars: 5,
      text: "Die Kombination aus Struktur, Community und persönlichem Feedback ist stark. Motivation, Disziplin und Ergebnisse ziehen sich durch den ganzen Prozess.",
    },
    {
      name: "Sarah W.",
      role: "6 Monate Coaching",
      stars: 5,
      text: "Tobias arbeitet ruhig, klar und konsequent. Ich habe an Kraft gewonnen, an Definition zugelegt und mich in meiner Gesundheit spürbar verbessert.",
    },
  ],
  successes: {
    stats: [
      { value: "120+", label: "Begleitete Kunden" },
      { value: "850+ kg", label: "Gemeinsam verloren" },
      { value: "10.000+", label: "Coaching-Stunden" },
      { value: "4.9 ★", label: "Kundenbewertung" },
    ],
    stories: [
      {
        name: "Marco S.",
        program: "6 Monate Coaching",
        before: "https://images.unsplash.com/photo-1518611012118-696072aa579a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        after: "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        result: "-14 kg · +6 kg Muskelmasse",
        quote:
          "Klare Struktur und konsequente Betreuung. Ich fühle mich messbar stärker und gesünder.",
      },
      {
        name: "Lisa K.",
        program: "3 Monate Coaching",
        before: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        after: "https://images.unsplash.com/photo-1567013127542-490d757e51fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        result: "-8 kg · sichtbar definierter",
        quote:
          "Ein System, das in meinen Alltag passt und mich dauerhaft dranbleiben lässt.",
      },
      {
        name: "Daniel R.",
        program: "6 Monate Coaching",
        before: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        after: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        result: "+8 kg Muskelmasse · stabilere Gesundheit",
        quote:
          "Mehr Energie, klarere Struktur, bessere Performance im Alltag und im Sport.",
      },
    ],
  },
  images: {
    hero: "/brand/hero-bg.jpg",
    about:
      "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    feature1:
      "https://images.unsplash.com/photo-1676655079738-af54dfd6318e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    feature2:
      "https://images.pexels.com/photos/14022551/pexels-photo-14022551.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    before: [
      "https://images.unsplash.com/photo-1518611012118-696072aa579a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
    after: [
      "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1567013127542-490d757e51fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
  },
  // SEO Keywords used for meta/og tags
  seo: {
    keywords: [
      "NNR Coaching",
      "Tobias Nunner Coaching",
      "Krafttraining Coaching",
      "Ernährungscoaching",
      "Trainingsplan kaufen",
      "Ernährungsplan kaufen",
      "Online Fitness Coaching",
      "1:1 Fitness Coaching",
      "Fitness Coach Rodgau",
      "Personal Coaching",
    ],
  },
};

export const waLink = () =>
  `https://wa.me/${SITE.contact.whatsapp}?text=${encodeURIComponent(SITE.whatsappMessage)}`;

export const telLink = () => `tel:${SITE.contact.phone.replace(/\s+/g, "")}`;
